<template>
  <section class="content-container">
    <div class="list">
      <div class="page__loader" v-if="isLoading">
        <LoadingLogo />
      </div>
      <div class="users__empty" v-else-if="!subscriptions.length">
        <h3>Подписки не найдены</h3>
      </div>
      <div v-else class="table-wrapper">
        <Table>
          <table>
            <thead>
              <th>Код</th>
              <th>Период</th>
              <th>Кол-во повторений</th>
              <th>Стоимость</th>
              <th>Код валюты</th>
              <th>Платформы</th>
              <th>Кол-во транзакций</th>
              <th>Дата обновления</th>
              <th>Дата создания</th>
              <th>Услуги</th>
              <th>Действия</th>
            </thead>
            <tbody>
              <tr
                v-for="subscription in subscriptions"
                :key="subscription.name"
              >
                <td>
                  <Chip :color="'white'">{{ subscription.name }}</Chip>
                </td>
                <td>{{ subscription.timeRange }}</td>
                <td>{{ subscription.timeRangeCount }}</td>
                <td>{{ subscription.amount }}</td>
                <td style="text-align: center">USD</td>
                <td>Все</td>
                <td>0</td>
                <td>{{ formatDate(getFieldValue(subscription, 'updatedAt', 'updated_at')) }}</td>
                <td>{{ formatDate(getFieldValue(subscription, 'createdAt', 'created_at')) }}</td>
                <td>{{ subscription.products?.length }} {{productsWord(subscription.products?.length)}}</td>
                <td>
                  <div class="table-actions">
                    <IconButton :icon="icons.edit" @click="openUpdateSubscriptionModal(subscription)" />
                    <IconButton :icon="icons.copy" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Table>
      </div>
    </div>
  </section>

  <!-- UPDATE SUBSCRIPTION DIALOG -->
  <UpdateSubscriptionDialog
    :subscription="selectedSubscription"
    v-show="selectedSubscription"
    @close="closeUpdateSubscriptionModal"
  />
  <!-- END UPDATE SUBSCRIPTION DIALOG -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import Search from '@/components/Search.vue'
// import Modal from '@/components/Modal.vue'
// import Pagination from '@/components/Pagination.vue'
// import Button from '@/components/Button.vue'
import LoadingLogo from "@/components/LoadingLogo.vue";
// import Alert from '@/components/Alert.vue'
// import Input from '@/components/Input.vue'
// import Select from '@/components/Select.vue'
// import SelectButtons from '@/components/SelectButtons.vue'
// import SvgIcon from '@jamescoyle/vue-icon';
import Chip from "@/components/Chip.vue";
import Table from "../components/Table.vue";
import {
  mdiClockRemove,
  mdiPencil,
  mdiDelete,
  mdiChartAreaspline,
  mdiPlus,
  mdiContentCopy,
} from "@mdi/js";
import IconButton from "@/components/IconButton.vue";
import releaseProductsMixin from "@/mixins/releaseProductsMixin";
import UpdateSubscriptionDialog from '@/components/payments/UpdateSubscriptionDialog.vue';
import { getFieldValue } from '@/utils/getFieldValue';

export default {
  mixins: [releaseProductsMixin],
  components: {
    // Search,
    // Modal,
    // Pagination,
    // Button,
    LoadingLogo,
    // Alert,
    // Input,
    // Select,
    Chip,
    // SelectButtons,
    // SvgIcon,
    Table,
    IconButton,
    UpdateSubscriptionDialog
  },

  data() {
    return {
      isLoading: false,
      selectedSubscription: null,
      icons: {
        clock: mdiClockRemove,
        edit: mdiPencil,
        delete: mdiDelete,
        chart: mdiChartAreaspline,
        plus: mdiPlus,
        copy: mdiContentCopy,
      },
    };
  },

  async mounted() {
    this.fetchSubscriptions();
  },

  computed: {
    ...mapGetters(["subscriptions"]),
  },

  methods: {
    getFieldValue,
    ...mapActions(["fetchSubscriptions"]),

    openUpdateSubscriptionModal(subscription){
      this.selectedSubscription = subscription
    },

    closeUpdateSubscriptionModal(){
      this.selectedSubscription = null
    },

    productsWord(productCount) {
      const pluralRules = new Intl.PluralRules("ru-RU");
      const rule = pluralRules.select(productCount);

      const product = {
        one: "услуга",
        few: "услуги",
        many: "услуг",
      };

      const productWord = product[rule] || "услуг";
      return productWord;
    },
  },

  watch: {},
};
</script>

<style lang="scss">
@import "@/assets/_shared.scss";
@import "@/assets/_nullstyle.scss";

.btns{
  display: flex;
}

.loading-survey {
  display: flex;
  justify-content: center;
  justify-items: center;
}

.text-wrapper {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.page__loader {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-container {
  padding-top: 90px;
  color: $white;
  display: flex;
  position: relative;

  .header-wrapper {
    display: flex;
    justify-content: space-between;
    margin-right: 25px;
    padding: 10px 0px;
  }

  .tools {
    padding-top: 30px;
    height: min-content;
    width: 480px;
    margin-right: 25px;
    display: flex;

    .create-btn {
      height: 52px;
      padding: 0;
      margin-left: 10px;
    }

    .tool {
      margin-bottom: 20px;
    }

    &__filters {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin: 8px 0 24px;
    }
  }

  &__loading {
    flex: 1;
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
  }

  .list {
    flex-grow: 1;
    height: 100%;
    // padding-top: 150px;
  }
}
</style>
